import { render, staticRenderFns } from "./goods-form.vue?vue&type=template&id=4d6bc74e&"
import script from "./goods-form.vue?vue&type=script&lang=js&"
export * from "./goods-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports